export interface IAllowAccessResponceProps {
  errorCode: string;
  formattedMessage: string;
  isSuccess: boolean;
}
export class AllowAcessResponce implements IAllowAccessResponceProps {
  errorCode = '';
  formattedMessage = '';
  isSuccess = true;

  public static fromJson = (data: AllowAcessResponce): AllowAcessResponce => {
    const model = new AllowAcessResponce();
    model.errorCode = data.errorCode;
    model.formattedMessage = data.formattedMessage;
    model.isSuccess = data.isSuccess;
    return model;
  };
}
